import React from 'react';
import { copyVisitsAPI } from '../../../api/protocol';
import { CopyVisits } from '../../../components/Protocols/Visit/CopyVisits';
import { useVisits } from './useVisits';

export const CopyVisitsContainer = ({ protocolId, onClose }) => {

    const [getVisits, data, setData, isLoading] = useVisits();

    const handleSelectedProtocol = (id) => {
        if (id) getVisits(id);
        else setData([]);
    }

    const handleCopyVisits = async (originProtocolId, selectedVisitIds, branchIds) => {
        if (!originProtocolId || !selectedVisitIds || selectedVisitIds.length === 0) return;

        await copyVisitsAPI(protocolId, originProtocolId, selectedVisitIds, branchIds);
        onClose();
    }

    return <CopyVisits
        onCopyVisits={handleCopyVisits}
        onSelectedProtocol={handleSelectedProtocol}
        onCancel={onClose}
        visits={data}
        isLoading={isLoading}
        destProtocolId={protocolId}
    />;
}